// project imports
import { createSlice } from '@reduxjs/toolkit';
import { theme } from '../../styles/theme';

// action - state management
import * as actionTypes from './types';

export const initialState = {
  isOpen: ["dashboard"], // for active default menu
  fontFamily: theme.typography.fontFamily,
  fontSize: '1.6rem',
  opened: true,
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationSlice = createSlice({
  name: 'customization',
  initialState: initialState,
  reducers: {
    setCustomization: (state, action) => {
      const data = action.payload;
      const type = action.payload.type;

      let id;
      switch (type) {
        case actionTypes.MENU_OPEN:
          id = data.id;
          return {
            ...state,
            isOpen: [id],
          };
        case actionTypes.SET_MENU:
          return {
            ...state,
            opened: data.opened,
          };
        case actionTypes.SET_FONT_FAMILY:
          return {
            ...state,
            fontFamily: data.fontFamily,
          };
        case actionTypes.SET_BORDER_RADIUS:
          return {
            ...state,
            borderRadius: data.borderRadius,
          };
        case actionTypes.SET_FONT_SIZE:
          return {
            ...state,
            fontSize: data.fontSize,
          };
        case actionTypes.SET_BACKGROUND_COLOR:
          return {
            ...state,
            backgroundColor: data.backgroundColor,
          };
        case actionTypes.SET_MODE:
          return {
            ...state,
            backgroundColor: data.mode,
          };
        default:
          return state;
      }
    }
  }
});


export const { setCustomization } = customizationSlice.actions;
export default customizationSlice.reducer;